<template>
  <div>
    <van-overlay :show="show" @click="show = false" style="position:fixed; top:0px; z-index:40;" align="right" >
      <van-image class="img" :src="iImg"  style="width: 285px;height: 229px;margin-top:20px;margin-right: 20px">
      </van-image>
    </van-overlay>
    <van-image class="img" style=" outline-width:0px; vertical-align:top; position:sticky; top:0px;z-index: 39" :src="aImg" @click="downloadWithBlob"></van-image>
    <div >
      <van-image class="img" style=" outline-width:0px; vertical-align:top; " :src="bImg"></van-image>
      <van-image class="img" style=" outline-width:0px; vertical-align:top; " :src="cImg"></van-image>
      <van-image class="img" style=" outline-width:0px; vertical-align:top; ":src="dImg"></van-image>
      <van-image class="img" style=" outline-width:0px; vertical-align:top; ":src="eImg"></van-image>
      <van-image class="img" style=" outline-width:0px; vertical-align:top; ":src="fImg"></van-image>
      <van-image class="img" style=" outline-width:0px; vertical-align:top; ":src="gImg"></van-image>
    </div>
    <van-image class="img" style=" outline-width:0px; vertical-align:top; position:fixed;bottom:5px;left:0px; padding: 0px 10px":src="hImg" @click="downloadWithBlob"></van-image>
  </div>
</template>

<script>

import aImg from '../img/a.png'
import bImg from '../img/b.png'
import cImg from '../img/c.png'
import dImg from '../img/d.png'
import eImg from '../img/e.png'
import fImg from '../img/f.png'
import gImg from '../img/g.png'
import hImg from '../img/h.png'
import iImg from '../img/i.png'

export default {
  name: "Index",
  data() {
    return {
      aImg:aImg,
      bImg:bImg,
      cImg:cImg,
      dImg:dImg,
      eImg:eImg,
      fImg:fImg,
      gImg:gImg,
      hImg:hImg,
      iImg:iImg,
      show:false,
    };
  },
  created() {
  },
  methods: {
    downloadWithBlob() {
      let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
      console.log(flag);
      if(flag == 'Android,Android' || flag =='iPhone,iPhone'){
        var ua = navigator.userAgent.toLowerCase();
        if(ua.match(/MicroMessenger/i)=="micromessenger") {
          this.show=true;
        } else if (ua.match(/QQ\//i) == "qq/") {
          this.show=true;
        }else {
          const a = document.createElement('a')
          a.href = "https://ccynice.bj.bcebos.com/qudao/gdt/tg01.apk" //下载的文件地址
          // a.download = name // 下载后文件名
          a.style.display = 'none'
          document.body.appendChild(a)
          a.click() // 点击下载
          document.body.removeChild(a)
        }
      }else{
        const a = document.createElement('a')
        a.href = "https://ccynice.bj.bcebos.com/qudao/gdt/tg01.apk" //下载的文件地址
        // a.download = name // 下载后文件名
        a.style.display = 'none'
        document.body.appendChild(a)
        a.click() // 点击下载
        document.body.removeChild(a)
      }
    },
  }
};
</script>

<style scoped>
>>> .van-overlay{
  position:fixed;
  top:0px;
  z-index:40;
}
</style>



// WEBPACK FOOTER //
// src/views/index.vue